import $ from 'jquery'
import showdown from 'showdown'

import colors from '../../../../lib/colors'

import { button, textarea } from '../../../../component/component'

var converter = new showdown.Converter({
  simpleLineBreaks: true,
  openLinksInNewWindow: true,
})

export function getTableDiv(value){

  var html = converter.makeHtml(value)

  var div =
    $('<div>')
    .append(html)
    .css({
      padding: '8px',
      pointerEvents: 'none',
    })

  return div

}

export function filterMatch(column,filter){

  if(!column.value){
    if(filter === 'null'){
      return true
    } else {
      return false
    }
  }

  if (column.value && filter == '*'){
    return true
  }

  var f = filter.toLowerCase()
  var c = column.value.toLowerCase()

  if(_.includes(c,f)){
    return true
  } else {
    return false
  }

}

export function getFormField(o,p,field){

  var format = function(value){
    return value
  }

  var parse = function(value){
    value = value.trim()
    return value
  }

  var validate = function(value){
    if(
      value ||
      field.optional
    ){
      p.change(field,value,true)
      labelDiv.setColor(colors.white)
      return true
    } else {
      p.change(field,value,false)
      labelDiv.setColor(colors.red.s_500)
      return false
    }
  }

  var edit = function(){

    var popupOverlay =
      $('<div>')
      .css({
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(3,0,0,0.5)',
        zIndex: 1,
      })
      .click(function(){
        popup.remove()
      })

    var popupInput =
      textarea()
      .css({
        height: '600px',
        maxHeight: '70%',
      })
      .attr({
        multiline: true,
        rows: 5,
      })
      .val(
        field.value
      )
      .on('input',function(){
        var value = popupInput.val()
        inputDiv.val(value)
        validate(parse(value))

      })

    var popupButton =
      button('confirm','fi-check',false,colors.white)
      .css({
        width: '100%',
        marginTop: '1px',
      })
      .click(function(){
        popup.remove()
      })

    var popupWindow =
      $('<div>')
      .css({
        maxWidth: '80%',
        width: '700px',
        zIndex: 2,
        textAlign: 'center',
        backgroundColor: 'black',
      })
      .append([
        popupInput,
        popupButton,
      ])

    var popup =
      $('<div>')
      .css({
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      })
      .append([
        popupOverlay,
        popupWindow,
      ])

    $('body')
    .append(popup)

  }

  var labelDiv =
    button(field.id,null,true)
    .css({
      display: 'block',
    })

  var disabled = field.edit ? false : true

  var inputDiv =
    textarea(disabled)
    .attr({
      multiline: true,
      rows: 5,
    })
    .val(
      format(field.value)
    )
    .on('input',function(){
      var value = inputDiv.val()
      validate(parse(value))
      console.log(parse(value))
    })

  var editDiv =
    button(null,'fi-pencil',false,colors.white)
    .css({
      display: 'block',
      position: 'absolute',
      top: 0,
      right: 0,
      borderTop: `1px solid ${colors.black}`,
      borderBottom: `1px solid ${colors.black}`,
    })
    .click(edit)

  var div =
    $('<div>')
    .css({
      position: 'relative'
    })
    .append(
      labelDiv,
      inputDiv,
    )

  if(field.edit){
    div.append(editDiv)
  }
  
  requestAnimationFrame(function(){
    var value = inputDiv.val()
    validate(parse(value))
  })

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/type/markdown/markdown.js